var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.b807aed6c2fb08ab6389de591250ec54.svg#l';
                    var viewUrl = 'sprites.b807aed6c2fb08ab6389de591250ec54.svg#view-l';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 19 18',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };